import { useRef, useState } from 'react'

import cn from 'classnames'

import styles from './styles.module.scss'
import RabbitImg from './images/rabbit.svg'
import ExchangeQuestion from './exchange-question'
import { ExchangeFaqProps } from './exchange-faq.props'

export default function ExchangeFaq({ questions, className, ...props }: ExchangeFaqProps) {
  const [currentId, setCurrentId] = useState<number>(-1)
  const imageRef = useRef(null)

  const handleOpen = (index: number) => {
    if (currentId === index) {
      setCurrentId(-1)
    } else {
      setCurrentId(index)
    }
  }

  return (
    <div className={cn(styles.faq, className)} {...props}>
      <div className={styles.questions}>
        {questions.map((question, index) => (
          <>
            <ExchangeQuestion
              question={question}
              currentId={currentId}
              questionId={index}
              handleOpen={() => handleOpen(index)}
            />
            <hr color="#cfe1fc" />
          </>
        ))}
      </div>
      <img ref={imageRef} className={styles.faq__img} src={RabbitImg} alt="rabbit image" />
    </div>
  )
}
